require('./services/static-categories');

module.exports = 'static-categories';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/static-categories/index.js
 ** module id = 114
 ** module chunks = 1
 **/